/*globals $:false */

import tmpl_container from '../templates/container.dot';
import tmpl_entry from '../templates/entry.dot';
import tmpl_entry_link from '../templates/entry-link.dot';
import tmpl_no_reports from '../templates/no-reports.dot';

/**
 * @param callbacks:
 *      - generateReport: the function called the when "Generate/Fill in" link is clicked;
 */
var ReportsV = function(core, $container, callbacks) {

    var _$reportsContainer = $(tmpl_container()),
        _$reportsNotFound = $(tmpl_no_reports()),
        _$reportList = $(".js-report-list", _$reportsContainer),
        _$entityReportList = $(".js-entity-report-list", _$reportsContainer),
        _$entityReportsTitle = $(".js-entity-reports-title", _$entityReportList);

    var _addReportToList = function(reportM){
        var $reportItem,
            $linkContainer,
            linkTranslation,
            linkText,
            reportHasEntities = reportM.hasReportEntities();

        $reportItem = $(tmpl_entry(
            {
                name:reportM.getReportName(),
                description: reportM.getReportDescription(),
                icon:"icon-bar-chart",
                disabled: reportHasEntities
            }
        ));

        if(reportHasEntities){
            //Show the entity reports section's title
            _$entityReportsTitle.removeClass("hidden");

            _$entityReportList.append($reportItem);

        }else{
            $linkContainer = $reportItem.find(".js-link-container");

            linkTranslation = reportM.hasParameters() ? "fill" : "generate";
            linkText = reportM.hasParameters() ? "Fill in" : "Generate";

            $linkContainer.append(tmpl_entry_link(
                {
                    fileName:reportM.getReportFileName(),
                    translation: linkTranslation,
                    text: linkText
                }));

            _$reportList.append($reportItem);
        }

    };

    var _init = function(){
        $container.on("click", ".js-report-link", function() {
            /* eslint-disable-next-line no-invalid-this  */
            callbacks.generateReport($(this).attr("data-report-name"));
        });

        _$reportsContainer.appendTo($container);
    };

    _init();

    return {
        showReports:function(reportsMs) {
            reportsMs.forEach(_addReportToList);

            core.translate("reportm", $container);
        },
        showNoReportsAvailable: function() {
            _$reportList.html(_$reportsNotFound);
            core.translate("reportm", $container);
        }
    };
};

export default ReportsV;
